import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    gridContainer: {
        padding: theme.spacing(6),
        display: "grid",
        gridTemplateColumns: "calc(25% - 9px) calc(25% - 9px) calc(25% - 9px) calc(25% - 9px)",
        gridTemplateRows: "calc(50% - 6px) calc(50% - 6px)",
        gap: theme.spacing(3),
        height: "calc(100vh - 146px)",
        width: "100vw",
        boxSizing: "border-box",
    },
}));
